import React, { Component } from 'react';
import FormField from "./FormField";

export default class VerticalFormField extends Component {

  render() {
    return(
      <FormField className="form-field vertical-input" {...this.props}/>
    )
  }
}



// WEBPACK FOOTER //
// ./src/elements/form/fields/VerticalFormField.js